import { Accordion } from "@smartfaster-ui/components";
import { useTranslation } from "react-i18next";
import { useInteriorDesigner } from "../context/InteriorDesignerContext";
import { isCtaEnabled, isRoomTypeLocked } from "../context/selectors";
import type { GenerationAction } from "../context/types";
import { useVocab } from "../hooks/useVocab";
import { ChipSelector } from "../selections/ChipSelector";
import { ExtraWishesInput } from "../selections/ExtraWishesInput";
import { ImageCardGrid } from "../selections/ImageCardGrid";
import { Panel } from "./Panel";

export function FurnishingPanel() {
  const { t } = useTranslation();
  const { state, dispatch } = useInteriorDesigner();
  const { vocab } = useVocab();

  const selections = state.panelSelections.furnishing;
  const ctaEnabled = isCtaEnabled({ state, panelId: "furnishing" });
  const roomTypeLocked = isRoomTypeLocked({ state });

  const handleCtaClick = () => {
    const actions: GenerationAction[] = [
      {
        type: "furnishing",
        style: selections.style ?? undefined,
        room_type: selections.room_type || undefined,
        extra_wensen: selections.extra_wensen || undefined,
      },
    ];
    dispatch({ type: "GENERATION_REQUESTED", actions });
  };

  return (
    <Panel
      ctaLabel={t("interiorDesigner.furnishing.cta")}
      ctaHintText={t("interiorDesigner.furnishing.ctaHint")}
      ctaEnabled={ctaEnabled}
      onCtaClick={handleCtaClick}
    >
      {vocab && (
        <Accordion
          multiple
          defaultValue={["styles", "roomType", "wishes"]}
          variant="filled"
          color="surfaceSecondary"
        >
          <Accordion.Item
            value="styles"
            title={t("interiorDesigner.furnishing.styles")}
          >
            <ImageCardGrid
              options={vocab.styles}
              value={selections.style}
              onValueChange={({ value }) =>
                dispatch({
                  type: "SELECTION_CHANGED",
                  panel: "furnishing",
                  field: "style",
                  value,
                })
              }
            />
          </Accordion.Item>

          <Accordion.Item
            value="roomType"
            title={t("interiorDesigner.furnishing.roomType")}
          >
            <ChipSelector
              options={vocab.room_types}
              value={selections.room_type}
              disabled={roomTypeLocked}
              allowDeselect={false}
              onValueChange={({ value }) =>
                dispatch({
                  type: "SELECTION_CHANGED",
                  panel: "furnishing",
                  field: "room_type",
                  value,
                })
              }
            />
          </Accordion.Item>

          <Accordion.Item
            value="wishes"
            title={t("interiorDesigner.furnishing.extraWishes")}
          >
            <ExtraWishesInput
              value={selections.extra_wensen}
              onValueChange={({ value }) =>
                dispatch({
                  type: "SELECTION_CHANGED",
                  panel: "furnishing",
                  field: "extra_wensen",
                  value,
                })
              }
            />
          </Accordion.Item>
        </Accordion>
      )}
    </Panel>
  );
}
